import React from "react";

export function LeaderCards({ leaders, divisionPlayers, teamName, perGame }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-14">
      {leaders.map((l) => {
        const top = [...divisionPlayers].sort((a, b) => b[l.key] - a[l.key])[0];
        return (
          <div key={l.key} className="border border-white/10 bg-[#121212] p-6 hover:shadow-[0_0_12px_rgba(255,87,34,0.3)] transition-all duration-200">
            <p className="text-xs uppercase tracking-[0.2em] text-[#FF5722] mb-4">{l.label} Leader</p>
            {top ? (
              <>
                <div className="font-display text-3xl uppercase">{top.name}</div>
                <div className="text-white/50 text-sm">{teamName(top.team_id)}</div>
                <div className="font-display text-6xl text-[#FF5722] tabular-nums mt-4">{top[l.key]}</div>
                <div className="text-white/40 text-xs uppercase tracking-wide">{perGame(top, l.key)} per game</div>
              </>
            ) : (
              <p className="text-white/40">No data</p>
            )}
          </div>
        );
      })}
    </div>
  );
}

export function StatsTable({ cols, sorted, sortKey, setSortKey, teamName, division }) {
  return (
    <>
      <div className="flex flex-wrap gap-2 mb-4">
        <span className="text-white/40 text-sm uppercase tracking-wide self-center mr-2">Sort by:</span>
        {cols.map((c) => (
          <button
            key={c.key}
            data-testid={`sort-${c.key}`}
            onClick={() => setSortKey(c.key)}
            className={`px-4 py-1.5 text-xs font-bold uppercase tracking-wide transition-all duration-200 ${
              sortKey === c.key ? "bg-[#FF5722] text-black" : "border border-white/15 text-white/60 hover:text-white"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      <div className="border border-white/10 bg-[#121212] overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/10 text-white/50 uppercase text-xs tracking-wider">
              <th className="text-left py-4 px-5">Player</th>
              <th className="text-left py-4 px-3">Team</th>
              <th className="text-center py-4 px-3">GP</th>
              {cols.map((c) => (
                <th key={c.key} className="text-center py-4 px-3">{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.length === 0 && (
              <tr><td colSpan={9} className="text-center py-10 text-white/40">No players in the {division} division yet.</td></tr>
            )}
            {sorted.map((p) => (
              <tr key={p.id} data-testid="stats-row" className="border-b border-white/5 last:border-0 hover:bg-white/5 transition-colors">
                <td className="py-3 px-5 font-semibold uppercase">
                  {p.number != null ? <span className="text-[#FF5722] mr-2 tabular-nums">#{p.number}</span> : null}
                  {p.name}
                </td>
                <td className="py-3 px-3 text-white/50">{teamName(p.team_id)}</td>
                <td className="text-center py-3 px-3 tabular-nums text-white/70">{p.games_played}</td>
                {cols.map((c) => (
                  <td key={c.key} className={`text-center py-3 px-3 tabular-nums ${sortKey === c.key ? "text-[#FF5722] font-bold" : "text-white/80"}`}>{p[c.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
